import { Component } from '@angular/core';

@Component({
  selector: 'app-workspaces',
  template: `<workspaces-list></workspaces-list>`,
})
export class WorkspacesComponent {}
